import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  totalAmounts: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: 16,
    margin: "10px 0 20px 0",
    width: "65%",
    [theme.breakpoints.down('lg')]: {
      width: "100%",
    },
    [theme.breakpoints.down('sm')]: {
      gap: 10,
    },
  },
  // `B3 · Stats-style + status-colored number` from the cards lab. Tinted
  // cornerGlow background and the status' primary color is computed inline
  // per-card in `AppStatsItems.tsx`.
  totalItem: {
    boxSizing: "border-box",
    width: "100%",
    minHeight: 110,
    padding: 20,
    display: "flex",
    alignItems: "center",
    gap: 16,
    border: "1px solid #eef0f7",
    borderRadius: 8,
    position: "relative",
    overflow: "hidden",
    [theme.breakpoints.down('sm')]: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: 0,
      padding: 14,
      minHeight: 0,
    },
  },
  iconTile: {
    width: 44,
    height: 44,
    borderRadius: 6,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    "& .MuiSvgIcon-root": {
      fontSize: 22,
    },
    [theme.breakpoints.down('sm')]: {
      width: 36,
      height: 36,
      "& .MuiSvgIcon-root": {
        fontSize: 20,
      },
    },
  },
  content: {
    minWidth: 0,
    [theme.breakpoints.down('sm')]: {
      marginTop: 10,
    },
  },
  amount: {
    fontSize: 26,
    fontWeight: 700,
    lineHeight: 1,
    [theme.breakpoints.down('sm')]: {
      fontSize: 22,
    },
  },
  label: {
    marginTop: 6,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    color: "#4a5280",
    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
      letterSpacing: "0.04em",
    },
  },
  mobileColumns: {
    border: "1px solid #DADFF6",
    width: "65%",
    paddingRight: 20,
    [theme.breakpoints.down('lg')]: {
      textAlign: "center",
      width: "100%",
      padding: 0,
    },
  },
  mobileTitle: { fontWeight: 600, padding: 20, display: "flex" },
}));
